import { render, staticRenderFns } from "./pickUpForm.vue?vue&type=template&id=336421cc&scoped=true"
import script from "./pickUpForm.vue?vue&type=script&lang=js"
export * from "./pickUpForm.vue?vue&type=script&lang=js"
import style0 from "./pickUpForm.vue?vue&type=style&index=0&id=336421cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336421cc",
  null
  
)

export default component.exports